module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('div', {
    staticClass: "headline pa-5"
  }, [_vm._v("Kontakte importieren")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }), _vm._v(" "), _c('v-icon', [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }), _vm._v(" "), _c('v-icon', [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }), _vm._v(" "), (_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('v-file-input', {
    attrs: {
      "accept": ".csv",
      "prepend-icon": "attach_file",
      "label": "CSV-Datei zum importieren auswählen"
    },
    model: {
      value: (_vm.csvDatei),
      callback: function($$v) {
        _vm.csvDatei = $$v
      },
      expression: "csvDatei"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importInNeueBbr
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("\n            Wähle die zu importierenden Spalten aus. Felder die keinen Wert zugewiesen bekommen werden nicht überschrieben.\n            "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Feld in Korpodesk")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Spalte in CSV-Datei")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kontaktfelder), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('td', [(_vm.kontaktfelder[item.id]) ? _c('v-autocomplete', {
      staticClass: "ma-0",
      attrs: {
        "clearable": "",
        "hide-details": "",
        "solo": "",
        "flat": "",
        "items": _vm.bbrNeuFelder
      },
      model: {
        value: (_vm.kontaktfelder[item.id].importiert),
        callback: function($$v) {
          _vm.$set(_vm.kontaktfelder[item.id], "importiert", $$v)
        },
        expression: "kontaktfelder[item.id].importiert"
      }
    }) : _vm._e()], 1)])
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.wechselHeader
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n            Doppelte Kontakte\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mr-1",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateImportStatus('Neuer Kontakt')
      }
    }
  }, [_vm._v("Alle Importieren")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mr-1",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateImportStatus('Original updaten')
      }
    }
  }, [_vm._v("Alle Updaten")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mr-1",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateImportStatus('Nicht importieren')
      }
    }
  }, [_vm._v("Alle nicht Importieren")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Hier werden alle Kontakte angezeigt, die schon in Korpodesk gefunden wurden. Entscheide für jeden einzeln ob du einen neuen Kontakt erstellen, den vorhanden updaten oder den Kontakt überspringen willst.\n            "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Importierter Kontakt (CSV-Datei)")]), _vm._v(" "), _c('th', [_vm._v("Vorhandener Kontakt (Klubdesk)")]), _vm._v(" "), _c('th', [_vm._v("Kontakt auswählen")]), _vm._v(" "), _c('th', [_vm._v("Übereinstimmung")]), _vm._v(" "), _c('th', [_vm._v("ToDo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrImportDoppelt), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.importiert.nachname) + ", " + _vm._s(item.importiert.vorname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.original.nachname) + ", " + _vm._s(item.original.vorname))]), _vm._v(" "), _c('td', [_c('v-autocomplete', {
      staticClass: "ma-0",
      attrs: {
        "hide-details": "",
        "items": _vm.bbrbbrKontaktImport
      },
      model: {
        value: (item.original),
        callback: function($$v) {
          _vm.$set(item, "original", $$v)
        },
        expression: "item.original"
      }
    })], 1), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.übereinstimmung))]), _vm._v(" "), _c('td', [_c('v-autocomplete', {
      staticClass: "ma-0",
      attrs: {
        "hide-details": "",
        "items": _vm.übernahmeItems
      },
      model: {
        value: (item.übernehmen),
        callback: function($$v) {
          _vm.$set(item, "übernehmen", $$v)
        },
        expression: "item.übernehmen"
      }
    })], 1)])
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.updateDoppelt
    }
  }, [_vm._v("Weiter")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Neue Kontakte (" + _vm._s(_vm.bbrImport.length) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrImport), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))])])
  }), 0)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Update Kontakte (" + _vm._s(_vm.bbrUpdate.length) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrUpdate), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.item.nachname) + ", " + _vm._s(item.item.vorname))])])
  }), 0)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 420px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nicht importierte Kontakte(" + _vm._s(_vm.bbrNichtImport.length) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bbrNichtImport), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.item.nachname) + ", " + _vm._s(item.item.vorname))])])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Zurück")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveNeueBbr
    }
  }, [_vm._v("In Kontakte Importieren")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5195f86f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogImportKontakte.vue
// module id = 778
// module chunks = 15